export const INFO_EMAIL = 'info.purport@gmail.com';
export const TASKS_NUMBER_LIMIT = 1000;
export const GLOBAL_TASK_MONTHS_NUMBER_LIMIT = 12;
export const REGULAR_TASK_MONTHS_NUMBER_LIMIT = 3;
export const LABEL_NUMBER_LIMIT = 10;
export const LOCAL_STORAGE_VARS = ['uid', 'language'];

export const API_URL = process.env.REACT_APP_API_URL;
export const TERMS_AND_CONDITIONS_URL = process.env.REACT_APP_TERMS_AND_CONDITIONS_URL;
export const PRIVACY_POLICY_URL = process.env.REACT_APP_PRIVACY_POLICY_URL;
export const REACT_APP_GOOGLE_PLAY_URL = process.env.REACT_APP_GOOGLE_PLAY_URL;

export const API_PATH_AUTH_SIGNUP = '/auth/signup';
export const API_PATH_AUTH_SIGNIN = '/auth/signin';
export const API_PATH_AUTH_SIGNIN_WITH_TOKEN = '/auth/signinWithToken';
export const API_PATH_AUTH_GOOGLE = '/auth/google';
export const API_PATH_AUTH_REFRESH = '/auth/refresh';
export const API_PATH_AUTH_PASSWORD_UPDATE = '/auth/passwordUpdate';
export const API_PATH_AUTH_PASSWORD_FORGET = '/auth/passwordForget';
export const API_PATH_AUTH_PASSWORD_SET = '/auth/passwordSet';
export const API_PATH_AUTH_LOGOUT = '/auth/logout';
export const API_PATH_USERS = '/users';
export const API_PATH_USERS_LANGUAGE = '/users/language';
export const API_PATH_USERS_DISABLE_TASKS_DONE = '/users/disableTasksDone';
export const API_PATH_USERS_DISABLE_ADVICE_SHOW = '/users/disableAdviceShow';
export const API_PATH_USERS_ADVICE_SHOWED_AT = '/users/adviceShowedAt';
export const API_PATH_USERS_SHOW_GLOBAL_TASKS_AS_LIST = '/users/showGlobalTasksAsList';
export const API_PATH_USERS_REGISTER_DEVICE_TOKEN = '/users/registerDeviceToken';
export const API_PATH_USERS_APP_VERSION = '/users/appVersion';
export const API_PATH_APP_VERSION = '/appVersion';
export const API_PATH_TASKS = '/tasks';
export const API_PATH_TASKS_GLOBAL = '/tasksGlobal';
export const API_PATH_TASKS_REGULAR = '/tasksRegular';
export const API_PATH_TASKS_SINGLE = '/tasksSingle';
export const API_PATH_TASKS_DELAYED = '/tasksDelayed';
export const API_PATH_LABELS = '/labels';

export const UNAUTHORIZED_STATUS_CODE = 401;
export const UNAUTHORIZED_MESSAGE = 'Unauthorized';

export const FETCH_ERROR_MESSAGE = 'Server error';

export const TASKS_GLOBAL = 'tasksGlobal';
export const TASKS_REGULAR = 'tasksRegular';
export const TASKS_SINGLE = 'tasksSingle';
export const TASKS_DELAYED = 'tasksDelayed';

export const EVENT_TYPE_REFRESH_TASKS = 'refresh_tasks';
export const EVENT_TYPE_REFRESH_LABELS = 'refresh_labels';
export const EVENT_TYPE_REFRESH_USER = 'refresh_user';
export const EVENT_TYPE_REFRESH_SHOW_GLOBAL_TASKS_AS_LIST = 'refresh_show_global_tasks_as_list';
export const EVENT_TYPE_REFRESH_DISABLE_TASKS_DONE = 'refresh_disable_tasks_done';
export const EVENT_TYPE_DISABLE_ADVICE_SHOW = 'refresh_disable_advice_show';
export const EVENT_TYPE_REFRESH_LANGUAGE = 'refresh_language';
